<template>
  <div class="box">
    <div class="header">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt />
      </div>
      <div class="btn-box">
        <div>
          <span :class="{ active: statues == 1 }" @click="statues = 1">登录</span>
        </div>
        <div>
          <span :class="{ active: statues == 2 }" @click="statues = 2">注册</span>
        </div>
      </div>
    </div>
    <div class="content">
      <z-login v-if="statues === 1"></z-login>
      <z-register v-else></z-register>
    </div>
  </div>
</template>

<script>
import zLogin from "./login";
import zRegister from "./register";

export default {
  data() {
    return {
      statues: 1
    };
  },
  components: {
    zLogin,
    zRegister
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.header {
  height: 225px;
  background: url("../../assets/images/black.jpg") 0 0;
  .logo {
    padding-top: 70px;
    img {
      display: block;
      width: 70px;
      height: 70px;
      margin: 0 auto;
    }
  }
  .btn-box {
    display: flex;
    margin-top: 46px;
    justify-content: space-evenly;
    color: #ffffff;
    span{font-size: 16px !important;}
    div {
      display: flex;
      width: 50%;
      text-align: center;
      justify-content: center;
      span {
        &.active::after {
          display: block;
          content: "";
          height: 3px;
          background: #ffffff;
          border-radius: 30px;
          margin-top: 10px;
        }
      }
    }
  }
}
.content {
  padding: 0 35px;
}
</style>
